import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Long: { input: number; output: number; }
  Void: { input: any; output: any; }
}

export interface Group {
  __typename?: 'Group';
  companyName: Scalars['String']['output'];
  orgReferenceId: Scalars['Long']['output'];
}

export interface Message {
  __typename?: 'Message';
  id: Scalars['Long']['output'];
  payload: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface MessageInput {
  /** Текст */
  text: Scalars['String']['input'];
  /** Заголовок */
  title: Scalars['String']['input'];
}

export interface Mutation {
  __typename?: 'Mutation';
  delete: Maybe<Scalars['Void']['output']>;
  deleteAll: Maybe<Scalars['Void']['output']>;
  deleteMultiple: Maybe<Scalars['Void']['output']>;
  read: Maybe<Scalars['Void']['output']>;
  readAll: Maybe<Scalars['Void']['output']>;
  readAllByOrigin: Maybe<Scalars['Void']['output']>;
  readMultiple: Maybe<Scalars['Void']['output']>;
  /** Отправка уведомления юзерам в компаниях с фильтрацией */
  sendToGroup: Array<Scalars['Long']['output']>;
}


export interface MutationDeleteArgs {
  notificationId: Scalars['Long']['input'];
}


export interface MutationDeleteMultipleArgs {
  notificationIdList: Array<Scalars['Long']['input']>;
}


export interface MutationReadArgs {
  notificationId: Scalars['Long']['input'];
}


export interface MutationReadAllByOriginArgs {
  origin: Origin;
}


export interface MutationReadMultipleArgs {
  notificationIdList: Array<Scalars['Long']['input']>;
}


export interface MutationSendToGroupArgs {
  notifyFilter: NotifyFilter;
}

export interface Notification {
  __typename?: 'Notification';
  dateTime: Scalars['DateTime']['output'];
  id: Scalars['Long']['output'];
  message: Message;
  origin: Origin;
  recipient: Scalars['String']['output'];
  status: NotificationStatus;
}

export enum NotificationStatus {
  Read = 'READ',
  Sent = 'SENT'
}

export interface Notify {
  message: MessageInput;
  origin: Origin;
  recipient: Scalars['String']['input'];
}

export interface NotifyFilter {
  /** base 64 эксель файла, где хранятся айди компаний, если данное поле не пустое, то игнорируется поле: orgReferenceIds */
  base64: InputMaybe<Scalars['String']['input']>;
  /** Данные об уведомлении */
  message: MessageInput;
  /** Айди компаний, если пустой список, то всем компаниям */
  orgReferenceIds: Array<Scalars['Long']['input']>;
  /** Каким ролям нужно отправить увед, если пустой список, то всем юзерам в компании */
  roles: Array<ObRoles>;
}

export enum ObRoles {
  /** Аудитор */
  Auditor = 'AUDITOR',
  /** Кассир */
  Cashier = 'CASHIER',
  /** Менеджер */
  CashManager = 'CASH_MANAGER',
  /** Исполнитель */
  Creator = 'CREATOR',
  /** Первый подписант */
  First = 'FIRST',
  /** Второй подписант */
  Second = 'SECOND'
}

export enum Origin {
  Elqr = 'ELQR',
  ImportSalary = 'IMPORT_SALARY',
  Letter = 'LETTER',
  Manual = 'MANUAL',
  Payment = 'PAYMENT',
  Robotics = 'ROBOTICS',
  Salary = 'SALARY',
  Statement = 'STATEMENT'
}

export interface PaginationRequest {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
}

export interface PaginationResponse {
  __typename?: 'PaginationResponse';
  currentPage: Scalars['Int']['output'];
  elementsInCurrentPage: Scalars['Long']['output'];
  groups: Array<Group>;
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
}

export interface Query {
  __typename?: 'Query';
  existNewNotifications: Scalars['Boolean']['output'];
  findAll: Array<Notification>;
  findAllUnread: Array<Notification>;
  findGroups: PaginationResponse;
}


export interface QueryFindGroupsArgs {
  companyName: Scalars['String']['input'];
  pagination: PaginationRequest;
}

export type NotificationFragment = { __typename?: 'Notification', id: number, recipient: string, status: NotificationStatus, origin: Origin, dateTime: any, message: { __typename?: 'Message', id: number, text: string | null, title: string, payload: string | null } };

export type MessageFragment = { __typename?: 'Message', id: number, text: string | null, title: string, payload: string | null };

export type ReadAllMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllMutation = { __typename?: 'Mutation', readAll: any | null };

export type ReadMutationVariables = Exact<{
  notificationId: Scalars['Long']['input'];
}>;


export type ReadMutation = { __typename?: 'Mutation', read: any | null };

export type DeleteMutationVariables = Exact<{
  notificationId: Scalars['Long']['input'];
}>;


export type DeleteMutation = { __typename?: 'Mutation', delete: any | null };

export type DeleteMultipleMutationVariables = Exact<{
  notificationIdList: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
}>;


export type DeleteMultipleMutation = { __typename?: 'Mutation', deleteMultiple: any | null };

export type ReadAllByOriginMutationVariables = Exact<{
  origin: Origin;
}>;


export type ReadAllByOriginMutation = { __typename?: 'Mutation', readAllByOrigin: any | null };

export type DeleteAllMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllMutation = { __typename?: 'Mutation', deleteAll: any | null };

export type FindAllQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAllQuery = { __typename?: 'Query', findAll: Array<{ __typename?: 'Notification', id: number, recipient: string, status: NotificationStatus, origin: Origin, dateTime: any, message: { __typename?: 'Message', id: number, text: string | null, title: string, payload: string | null } }> };

export type ExistNewNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExistNewNotificationsQuery = { __typename?: 'Query', existNewNotifications: boolean };

export const MessageFragmentDoc = gql`
    fragment Message on Message {
  id
  text
  title
  payload
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on Notification {
  id
  recipient
  message {
    ...Message
  }
  status
  origin
  dateTime
}
    ${MessageFragmentDoc}`;
export const ReadAllDocument = gql`
    mutation readAll {
  readAll
}
    `;
export const ReadDocument = gql`
    mutation read($notificationId: Long!) {
  read(notificationId: $notificationId)
}
    `;
export const DeleteDocument = gql`
    mutation delete($notificationId: Long!) {
  delete(notificationId: $notificationId)
}
    `;
export const DeleteMultipleDocument = gql`
    mutation deleteMultiple($notificationIdList: [Long!]!) {
  deleteMultiple(notificationIdList: $notificationIdList)
}
    `;
export const ReadAllByOriginDocument = gql`
    mutation readAllByOrigin($origin: Origin!) {
  readAllByOrigin(origin: $origin)
}
    `;
export const DeleteAllDocument = gql`
    mutation deleteAll {
  deleteAll
}
    `;
export const FindAllDocument = gql`
    query findAll {
  findAll {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export const ExistNewNotificationsDocument = gql`
    query existNewNotifications {
  existNewNotifications
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    readAll(variables?: ReadAllMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReadAllMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReadAllMutation>(ReadAllDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'readAll', 'mutation', variables);
    },
    read(variables: ReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReadMutation>(ReadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'read', 'mutation', variables);
    },
    delete(variables: DeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMutation>(DeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'delete', 'mutation', variables);
    },
    deleteMultiple(variables: DeleteMultipleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteMultipleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteMultipleMutation>(DeleteMultipleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteMultiple', 'mutation', variables);
    },
    readAllByOrigin(variables: ReadAllByOriginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReadAllByOriginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReadAllByOriginMutation>(ReadAllByOriginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'readAllByOrigin', 'mutation', variables);
    },
    deleteAll(variables?: DeleteAllMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteAllMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAllMutation>(DeleteAllDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAll', 'mutation', variables);
    },
    findAll(variables?: FindAllQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAllQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAllQuery>(FindAllDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAll', 'query', variables);
    },
    existNewNotifications(variables?: ExistNewNotificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExistNewNotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExistNewNotificationsQuery>(ExistNewNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'existNewNotifications', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;